import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText } from 'lucide-react';

const TermsPage = () => {
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-pink-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card>
          <CardHeader>
            <div className="flex items-center justify-center mb-4">
              <FileText className="h-12 w-12 text-purple-600" />
            </div>
            <CardTitle className="text-3xl text-center">
              {isEnglish ? 'Terms of Sale Agreement' : 'Mesafeli Satış Sözleşmesi'}
            </CardTitle>
          </CardHeader>
          <CardContent className="prose max-w-none">
            {isEnglish ? (
              <div className="space-y-6 text-gray-700">
                <h3 className="text-xl font-semibold text-gray-900">1. Subject</h3>
                <p className="leading-relaxed">
                  This agreement pertains to the sale of digital services offered through the Pilatika platform.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">2. Services</h3>
                <p className="leading-relaxed">
                  Services purchased include live class participation, recorded video lessons, or digital education packages.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">3. Service Delivery</h3>
                <p className="leading-relaxed">
                  Due to the digital nature of the service, service delivery begins immediately after the purchase is completed. Digital content is made accessible through the platform after payment confirmation.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">4. Price and Payment</h3>
                <p className="leading-relaxed">
                  All prices are displayed in Turkish Lira (TRY) including taxes. Payments are securely processed through iyzico infrastructure.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">5. Seller Information</h3>
                <ul className="list-none space-y-1">
                  <li><strong>Company:</strong> Pilatika</li>
                  <li><strong>Website:</strong> www.pilatika.com</li>
                  <li><strong>Email:</strong> info@pilatika.com</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-900">6. Buyer's Obligations</h3>
                <p className="leading-relaxed">
                  The buyer agrees not to share, distribute, or reproduce purchased digital content. Content is licensed for personal use only.
                </p>
              </div>
            ) : (
              <div className="space-y-6 text-gray-700">
                <h3 className="text-xl font-semibold text-gray-900">1. Konu</h3>
                <p className="leading-relaxed">
                  Bu sözleşme, Pilatika platformu üzerinden sunulan dijital hizmetlerin satışına ilişkindir.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">2. Hizmetler</h3>
                <p className="leading-relaxed">
                  Satın alınan hizmetler; canlı ders katılımı, kayıtlı ders videoları veya dijital eğitim paketlerinden oluşur.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">3. Hizmet Teslimi</h3>
                <p className="leading-relaxed">
                  Hizmetin dijital içerik olması nedeniyle, satın alma işlemi tamamlandıktan sonra hizmet ifasına başlanır. Dijital içerikler, ödeme onayından sonra platform üzerinden erişilebilir hale getirilir.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">4. Fiyat ve Ödeme</h3>
                <p className="leading-relaxed">
                  Tüm fiyatlar vergiler dahil Türk Lirası (TL) olarak gösterilmektedir. Ödemeler iyzico altyapısı üzerinden güvenli şekilde gerçekleştirilir.
                </p>

                <h3 className="text-xl font-semibold text-gray-900">5. Satıcı Bilgileri</h3>
                <ul className="list-none space-y-1">
                  <li><strong>Firma:</strong> Pilatika</li>
                  <li><strong>Web Sitesi:</strong> www.pilatika.com</li>
                  <li><strong>E-posta:</strong> info@pilatika.com</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-900">6. Alıcının Yükümlülükleri</h3>
                <p className="leading-relaxed">
                  Alıcı, satın aldığı dijital içerikleri paylaşmamayı, dağıtmamayı veya çoğaltmamayı kabul eder. İçerikler yalnızca kişisel kullanım için lisanslanmıştır.
                </p>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsPage;
